export class TagsManagement {
  public id: number;
  public description?: string;
  public ordreAffichage?: number;
  public defaultEntrant?: boolean;
  public defaultSortant?: boolean;
  public color?: string;
  public notUsed?: boolean;
  public cocherAjouterDroitAccesGroupeID?: number;
  public courrierActionDroitCocherGroupeID?: number;
  public courrierActionDroitDecocherGroupeID?: number;
  public visionArbre?: string;
  public servicesAuthorized?: Array<number>;
  public serviceName?: string;

  constructor(data: Partial<TagsManagement>) {
    Object.assign(this, data);
  }
}
